import IndexedDB from "@/helpers/IndexedDB.js";

export default class User {
	access_token = "";
	added_on = "";
	additional_info = "";
	code_recover_date = "";
	code_recover_pass = "";
	company_id = "";
	company_name = "";
	created_at = "";
	email = "";
	expire_token = "";
	id = "";
	identification = "";
	lastname = "";
	name = "";
	permissions = "";
	role_id = "";
	role_name = "";
	status = "";
	status_id = "";
	typology_id = "";
	typology_name = "";
	uid = "";
	update_on = "";
	username = "";

	constructor(data = null) {
		if (data) {
			this.access_token = data["access_token"];
			this.added_on = data["added_on"];
			this.additional_info = data["additional_info"];
			this.code_recover_date = data["code_recover_date"];
			this.code_recover_pass = data["code_recover_pass"];
			this.company_id = data["datarutas_company_id"];
			this.company_name = data["datarutas_company_name"];
			this.created_at = data["created_at"];
			this.email = data["email"];
			this.expire_token = data["expire_token"];
			this.id = data["datarutas_id"];
			this.identification = data["identification"];
			this.lastname = data["lastname"];
			this.name = data["name"];
			this.permissions = data["datarutas_permissions"];
			this.role_id = data["datarutas_role_id"];
			this.role_name = data["datarutas_role_name"];
			this.status = data["datarutas_status"];
			this.status_id = data["status_id"];
			this.typology_id = data["typology_id"];
			this.typology_name = data["typology_name"];
			this.uid = data["uid"];
			this.update_on = data["update_on"];
			this.username = data["username"];

			// this.saveToken(this.access_token);
			this.saveUid(this.uid);
		}
	}

	saveUid(uid) {
		localStorage.setItem("data-ruta-uid", uid);
	}

	isLogin() {
		return localStorage.getItem("data-ruta-uid") ? true : false;
	}

	/*saveToken(token) {
		localStorage.setItem('accessToken', token);
	}*/

	async getToken() {
		if (this.isLogin()) {
			const uid = localStorage.getItem("data-ruta-uid");
			const query = {uid};
			const result = await IndexedDB.where_("users", query, {query: "first"});
			return result.access_token;
		} else {
			return null;
		}
	}

	async getUser() {
		const uid = localStorage.getItem("data-ruta-uid");
		const query = {uid};
		const result = await IndexedDB.getKey("users", query.uid);
		return result;
	}

	async clearUser() {
		localStorage.removeItem("data-ruta-uid");
		await IndexedDB.truncate("users", null);
	}

	async deleteUserIndexed() {
		const uid = localStorage.getItem("data-ruta-uid");
		const query = {uid};
		const result = await IndexedDB.deleteKey("users", query.uid);
		return result;
	}
}
